export const baseColumnListDefault = [
  {
    field: 'docType',
    title: '单据类型',
  },
  {
    field: 'goodsTypeName',
    title: '货物类型',
  },
  {
    field: 'goodsCategoryName',
    title: '货物品类',
  },
  {
    field: 'goodsModel',
    title: '货物规格/型号',
  },
  {
    field: 'weight',
    title: '重量',
  },
  {
    field: 'quantity',
    title: '数量',
  },
  {
    field: 'unitName',
    title: '单位',
  },
  {
    field: 'inOutStockDate',
    title: '入库/出库时间',
  },
  {
    field: 'consignorName',
    title: '发货人',
  },
  {
    field: 'keeperName',
    title: '保管员',
  },
  {
    field: 'remark',
    title: '备注',
  },
];
